module.exports = __webpack_public_path__ + "img/pet-paradise.a5e16492.webp";